/** Огноо/цагийг Улаанбаатарын цагийн бүсээр (UTC+8) харуулна.
 *  Сервер ISO (UTC) буцаадаг; цагийн бүсгүй мөрийг UTC гэж үзнэ. */
export const UB_TZ = 'Asia/Ulaanbaatar';

function toDate(v: any): Date | null {
  if (!v) return null;
  if (v instanceof Date) return v;
  let s = String(v);
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return null;              // зөвхөн огноо — хөрвүүлэхгүй
  if (/\d{2}:\d{2}/.test(s) && !/[zZ]|[+-]\d{2}:?\d{2}$/.test(s)) s = s.replace(' ', 'T') + 'Z';
  const d = new Date(s);
  return isNaN(d.getTime()) ? null : d;
}
const pad = (n: number) => String(n).padStart(2, '0');
function parts(d: Date) {
  const p = new Intl.DateTimeFormat('en-GB', { timeZone: UB_TZ, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false }).formatToParts(d);
  const g = (t: string) => p.find(x => x.type === t)?.value || '';
  return { y: g('year'), m: g('month'), d: g('day'), h: g('hour') === '24' ? '00' : g('hour'), mi: g('minute'), s: g('second') };
}
/** 2026-09-18 10:14 (УБ) */
export function fmtDateTime(v: any, fallback = '—'): string {
  const d = toDate(v); if (!d) return v ? String(v).slice(0, 16).replace('T', ' ') : fallback;
  const q = parts(d); return `${q.y}-${q.m}-${q.d} ${q.h}:${q.mi}`;
}
/** 2026-09-18 (УБ) */
export function fmtDate(v: any, fallback = '—'): string {
  const d = toDate(v); if (!d) return v ? String(v).slice(0, 10) : fallback;
  const q = parts(d); return `${q.y}-${q.m}-${q.d}`;
}
/** Өнөөдрийн огноо УБ-аар YYYY-MM-DD (input type=date-д) */
export function todayUB(): string { const q = parts(new Date()); return `${q.y}-${q.m}-${q.d}`; }
export { pad };
